import { RdsTextItem } from './text-item.model';

export interface RdsDialogLink extends RdsTextItem {
  /** Message to display in a dialog, supports HTML markup. */
  dialog: string;
}

export function instanceOfRdsDialogLink(something: any): something is RdsDialogLink {
  return !!something && !!something.dialog;
}
